import { dateProvider } from '@utils';
import type { TFunction } from 'i18next';

export const formatDateTitle = (
  dateString: string,
  t: TFunction<'StudentDashboardTranslations'>
) => {
  if (!dateString) return '';

  const date = dateProvider.parse(dateString, 'yyyy-MM-dd');
  const today = dateProvider.format(dateProvider.now(), 'yyyy-MM-dd');
  const isToday = dateString === today;

  const dayOfWeek = date.getDay();
  const weekdayKeys = [
    'WEEKDAY_FULL_SUNDAY',
    'WEEKDAY_FULL_MONDAY',
    'WEEKDAY_FULL_TUESDAY',
    'WEEKDAY_FULL_WEDNESDAY',
    'WEEKDAY_FULL_THURSDAY',
    'WEEKDAY_FULL_FRIDAY',
    'WEEKDAY_FULL_SATURDAY'
  ] as const;

  const month = date.getMonth();
  const monthKeys = [
    'MONTH_JANUARY',
    'MONTH_FEBRUARY',
    'MONTH_MARCH',
    'MONTH_APRIL',
    'MONTH_MAY',
    'MONTH_JUNE',
    'MONTH_JULY',
    'MONTH_AUGUST',
    'MONTH_SEPTEMBER',
    'MONTH_OCTOBER',
    'MONTH_NOVEMBER',
    'MONTH_DECEMBER'
  ] as const;

  const dayName = t(weekdayKeys[dayOfWeek]);
  const monthName = t(monthKeys[month]);
  const dayNumber = date.getDate();

  const capitalizedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);

  if (isToday) {
    return `${t('TODAY')}, ${capitalizedDayName} ${dayNumber} de ${monthName}`;
  } else {
    return `${capitalizedDayName} ${dayNumber} de ${monthName}`;
  }
};
